// Components/WorkTransfer/dormancy.js
//
// "Days quiet" tiering (2026-08-19), ported from the CP Sourcing module's
// dormancy tiers (14-29/30-59/60+ days) onto leads instead of CPs. Computed
// client-side from `last_updated_at` (already present on every leadsfilter
// row, confirmed live) — no backend change needed for this part.

export function dormancyDays(lastUpdatedAtMs) {
  if (!lastUpdatedAtMs) return null;
  return Math.floor((Date.now() - lastUpdatedAtMs) / (1000 * 60 * 60 * 24));
}

export function dormancyTier(days) {
  if (days == null) return null;
  if (days >= 60) return "critical";
  if (days >= 30) return "escalate";
  if (days >= 14) return "outreach";
  return null;
}

export function dormancyLabel(days) {
  if (days == null) return null;
  return `${days} day${days === 1 ? "" : "s"} quiet`;
}

// "Never active" — approximated as a Nurturing-bucket lead that never
// progressed past "Claimed" (i.e. never reached "Site Visit Scheduled" or
// beyond). There's no separate "a site visit row was ever created" flag to
// check directly, so this is a judgment call using data already on hand, not
// a stored fact — flagging it here rather than in five call sites.
export function isNeverActive(lead, bucketName) {
  return bucketName === "Nurturing" && lead.leadstatus === "Claimed";
}
